import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { isAnimationControls } from '../../../animation/utils/is-animation-controls.mjs';
import { createAnimationState } from '../../../render/utils/animation-state.mjs';
import { Feature } from '../Feature.mjs';
var AnimationFeature = /*#__PURE__*/function (_Feature) {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  function AnimationFeature(node) {
    var _this;
    _classCallCheck(this, AnimationFeature);
    _this = _callSuper(this, AnimationFeature, [node]);
    node.animationState || (node.animationState = createAnimationState(node));
    return _this;
  }
  _inherits(AnimationFeature, _Feature);
  return _createClass(AnimationFeature, [{
    key: "updateAnimationControlsSubscription",
    value: function updateAnimationControlsSubscription() {
      var _this$node$getProps = this.node.getProps(),
        animate = _this$node$getProps.animate;
      if (isAnimationControls(animate)) {
        this.unmountControls = animate.subscribe(this.node);
      }
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */
  }, {
    key: "mount",
    value: function mount() {
      this.updateAnimationControlsSubscription();
    }
  }, {
    key: "update",
    value: function update() {
      var _this$node$getProps2 = this.node.getProps(),
        animate = _this$node$getProps2.animate;
      var _ref = this.node.prevProps || {},
        prevAnimate = _ref.animate;
      if (animate !== prevAnimate) {
        this.updateAnimationControlsSubscription();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _a;
      this.node.animationState.reset();
      (_a = this.unmountControls) === null || _a === void 0 ? void 0 : _a.call(this);
    }
  }]);
}(Feature);
export { AnimationFeature };